import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved. A splat, bare old URL included: a route file at the old path would share the new one's name.
export const Route = createFileRoute('/_authenticated/suppliers/$supplierId/supplier-contacts-importer/$')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // No `validateSearch`, like the other splats: the target's validator reads the query string.
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/suppliers/$supplierId/supplier-contacts/importer',
            params: { supplierId: params.supplierId },
            search: true,
            replace: true,
        });
    },
});
